import HTTPResponseEntity        from '@/js/Shared/Services/HTTP/Entities/HTTPResponseEntity.js';
import SmokescreenCollectionList from '../Collections/SmokescreenCollectionList.js';
import SmokecreenItem            from '../Entities/SmokecreenItem.js';

export { SmokescreenHTTPMapping as default };

/**
* Smokescreen HTTP Mapping
*
* This class maps the HTTP responses to Smokescreen Data objects
*
* @author      rsommerfeld <roni.s.sommerfeld@altice.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class SmokescreenHTTPMapping
{
    /**
     * Resets an entire smokescreen addresses list and maps new items from server response
     *
     * @public
     *
     * @since 7.0.0
     *
     * @param {SmokescreenCollectionList} data     Smokescreen addresses data item
     * @param {HTTPResponseEntity}        response http response entity
     *
     * @return {void}
     */
    mapList(data, response) {

        if (!response.results) {
            return;
        }

        data.reset();

        response.results.forEach((item) => {
            data.add(this.mapItem(data, item))
        });
    }

    /**
     * Adds item to the smokescreen collection list
     *
     * @public
     *
     * @since 7.0.0
     *
     * @param {SmokescreenCollectionList} data     Smokescreen addresses data item
     * @param {HTTPResponseEntity}        response http response entity
     *
     * @return {void}
     */
    mapAddItem(data, response) {
        if (!response.results) {
            return;
        }

        let item = this.mapItem(data, response.results);
        data.add(item);
        data.resortItems();
    }

    mapEnableItem(item) {
        item.active = true;
    }

    mapDisableItem(item) {
        item.active = false;
    }

    /**
     * Maps the values from the server response item into a SmokecreenItem
     *
     * @public
     *
     * @since 7.0.0
     *
     * @param {SmokescreenCollectionList} data        Smokescreen addresses data item
     * @param {Object}                    result_item item from server response
     *
     * @return {SmokecreenItem}
     */
    mapItem(data, result_item){
        let item = (data.exists(result_item.address))
                 ? data.get(result_item.address)
                 : new SmokecreenItem();

        item.address = result_item.address;
        item.active  = result_item.status === 'ENABLED' ? true : false;
        item.date    = result_item.modified_date;

        return item;
    }
}